module.exports = __webpack_public_path__ + "img/nr.df32b38f.svg";